import * as React from 'react';

const LoggedOutIcon: React.FC = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='82'
		height='82'
		fill='none'
		viewBox='0 0 82 82'>
		<path
			fill='#B5D5EA'
			stroke='#B5D5EA'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth='2.986'
			d='M9.225 71.416c0 .375.11.739.314 1.032.203.292.486.496.802.577l22.778 5.86c.208.054.423.052.631-.004.207-.056.401-.165.568-.32.166-.154.3-.35.392-.572.092-.223.14-.466.14-.713V4.723c0-.247-.048-.49-.14-.713a1.6 1.6 0 0 0-.392-.573 1.36 1.36 0 0 0-.568-.32 1.23 1.23 0 0 0-.631-.004L10.34 8.977c-.316.08-.6.285-.802.577a1.8 1.8 0 0 0-.314 1.032z'></path>
		<path
			stroke='#B5D5EA'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth='2.986'
			d='M78.647 42.025H39.363M65.551 55.118l13.095-13.094L65.55 28.93'></path>
		<path
			stroke='#0973BA'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth='2.986'
			d='M78.647 44.074H39.363M65.551 57.17l13.095-13.095L65.55 30.98M32.816 9.902h24.552a1.637 1.637 0 0 1 1.636 1.637v8.184M59.004 62.28v8.183a1.637 1.637 0 0 1-1.636 1.637H32.816M3.353 71.192a1.64 1.64 0 0 0 1.284 1.597l26.188 5.817a1.636 1.636 0 0 0 1.99-1.597V4.989a1.636 1.636 0 0 0-1.99-1.597L4.637 9.212a1.64 1.64 0 0 0-1.284 1.598z'></path>
		<path
			stroke='#0973BA'
			strokeLinecap='round'
			strokeLinejoin='round'
			strokeWidth='2.986'
			d='M16.449 41.002a4.91 4.91 0 1 0 9.82 0 4.91 4.91 0 0 0-9.82 0'></path>
	</svg>
);

export default LoggedOutIcon;
